export const AUTH_USER = 'auth_user';
export const AUTH_ERROR_SIGNUP = "auth_error_signup";
export const AUTH_ERROR_LOGIN = "auth_error_login";
export const DEAUTH_USER = 'deauth_user';
export const UPDATE_USER_BASIC = 'update_user_basic';
export const FETCH_USER_ACTIVITIES = "FETCH_USER_ACTIVITIES"
export const FETCH_ACTIVITY_FOR_EDITTING = "FETCH_ACTIVITY_FOR_EDITTING"
export const FETCH_USER_FAVORITES = "FETCH_USER_FAVORITES";
export const DELETE_USER_FAVORITE = "DELETE_USER_FAVORITE";
export const FETCH_COMMENTS = "FETCH_COMMENTS";

export const FETCH_WISH_FOR_EDITTING = "FETCH_WISH_FOR_EDITTING";
export const FETCH_USER_WISHES = "FETCH_USER_WISHES";

export const FETCH_SEARCH_DATA = 'fetch_search_data';
export const FETCH_HISTORY_DATA ='fetch_history_data';
export const CLEAR_HISTORY_DATA = 'clear_history_data';

export const FETCH_MAIN_DATA = 'fetch_main_data';
export const FETCH_WISH_DATA = 'fetch_wish_data';

export const FETCH_STORY_DATA = 'fetch_story_data';
export const FETCH_ACTIVITY_DATA = 'fetch_activity_data';
export const ADD_ACTIVITY_DATA = 'add_activity_data';
export const ACTIVITY_ERROR = 'activity_error';
export const ADD_WISH_DATA = 'add_wish_data';
export const WISH_ERROR = "wish_error";
export const HANDLE_LIKES = "handle_likes";
export const FETCH_ONE_ACTIVITY = "fetch_one_activity";
export const FETCH_ONE_WISH = "fetch_one_wish";

export const FETCH_PROFILE_DATA = 'fetch_profile_data';
export const ADD_RATING_DATA = 'add_rating_data';
export const FETCH_RATING_DATA = 'fetch_rating_data';
export const RATING_ERROR = 'rating_error';
export const FETCH_OVERALL_RATING = 'overall_error';
export const HANDLE_WISH_LIKES = "handle_wish_likes";


export const INPUT_ERROR = "INPUT_ERROR";
export const IS_YOUR_FAV = "IS_YOUR_FAV";
export const UPLOAD_NEW_IMAGE = "UPLOAD_NEW_IMAGE";
export const IMAGE_ERROR = "IMAGE_ERROR";


// WEBPACK FOOTER //
// ./src/Actions/types.js